import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { S3ExpressIdentityCache } from "./S3ExpressIdentityCache";
import { S3ExpressIdentityCacheEntry } from "./S3ExpressIdentityCacheEntry";
export var S3ExpressIdentityProviderImpl = /*#__PURE__*/function () {
  function S3ExpressIdentityProviderImpl(createSessionFn) {
    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new S3ExpressIdentityCache();
    _classCallCheck(this, S3ExpressIdentityProviderImpl);
    this.createSessionFn = createSessionFn;
    this.cache = cache;
  }
  _createClass(S3ExpressIdentityProviderImpl, [{
    key: "getS3ExpressIdentity",
    value: function () {
      var _getS3ExpressIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(awsIdentity, identityProperties) {
        var _this = this;
        var key, cache, entry;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = identityProperties.Bucket;
                cache = this.cache;
                entry = cache.get(key);
                if (!entry) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", entry.identity.then(function (identity) {
                  var _identity$expiration$, _identity$expiration, _identity$expiration$2, _identity$expiration2;
                  var isExpired = ((_identity$expiration$ = (_identity$expiration = identity.expiration) === null || _identity$expiration === void 0 ? void 0 : _identity$expiration.getTime()) !== null && _identity$expiration$ !== void 0 ? _identity$expiration$ : 0) < Date.now();
                  if (isExpired) {
                    return cache.set(key, new S3ExpressIdentityCacheEntry(_this.getIdentity(key))).identity;
                  }
                  var isExpiringSoon = ((_identity$expiration$2 = (_identity$expiration2 = identity.expiration) === null || _identity$expiration2 === void 0 ? void 0 : _identity$expiration2.getTime()) !== null && _identity$expiration$2 !== void 0 ? _identity$expiration$2 : 0) < Date.now() + S3ExpressIdentityProviderImpl.REFRESH_WINDOW_MS;
                  if (isExpiringSoon && !entry.isRefreshing) {
                    entry.isRefreshing = true;
                    _this.getIdentity(key).then(function (id) {
                      cache.set(key, new S3ExpressIdentityCacheEntry(Promise.resolve(id)));
                    });
                  }
                  return identity;
                }));
              case 5:
                return _context.abrupt("return", cache.set(key, new S3ExpressIdentityCacheEntry(this.getIdentity(key))).identity);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getS3ExpressIdentity(_x, _x2) {
        return _getS3ExpressIdentity.apply(this, arguments);
      }
      return getS3ExpressIdentity;
    }()
  }, {
    key: "getIdentity",
    value: function () {
      var _getIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var _session$Credentials, _session$Credentials2;
        var session, identity;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.cache.purgeExpired().catch(function (error) {
                  console.warn("Error while clearing expired entries in S3ExpressIdentityCache: \n" + error);
                });
              case 2:
                _context2.next = 4;
                return this.createSessionFn(key);
              case 4:
                session = _context2.sent;
                if (!(!((_session$Credentials = session.Credentials) !== null && _session$Credentials !== void 0 && _session$Credentials.AccessKeyId) || !((_session$Credentials2 = session.Credentials) !== null && _session$Credentials2 !== void 0 && _session$Credentials2.SecretAccessKey))) {
                  _context2.next = 7;
                  break;
                }
                throw new Error("s3#createSession response credential missing AccessKeyId or SecretAccessKey.");
              case 7:
                identity = {
                  accessKeyId: session.Credentials.AccessKeyId,
                  secretAccessKey: session.Credentials.SecretAccessKey,
                  sessionToken: session.Credentials.SessionToken,
                  expiration: session.Credentials.Expiration ? new Date(session.Credentials.Expiration) : undefined
                };
                return _context2.abrupt("return", identity);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getIdentity(_x3) {
        return _getIdentity.apply(this, arguments);
      }
      return getIdentity;
    }()
  }]);
  return S3ExpressIdentityProviderImpl;
}();
S3ExpressIdentityProviderImpl.REFRESH_WINDOW_MS = 60000;